/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ItemVariantGroupRequest } from '../../models/item-variant-group-request';

export interface ItemVariantGroupsItemVariantGroupIdPut$Params {
  'Active-Tenant-Identifier': string;
  itemVariantGroupId: string;
      body: ItemVariantGroupRequest
}

export function itemVariantGroupsItemVariantGroupIdPut(http: HttpClient, rootUrl: string, params: ItemVariantGroupsItemVariantGroupIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, itemVariantGroupsItemVariantGroupIdPut.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('itemVariantGroupId', params.itemVariantGroupId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

itemVariantGroupsItemVariantGroupIdPut.PATH = '/item-variant-groups/{itemVariantGroupId}';
